interface DemoHoverBoxProps {
    title: string;
    description: string;
    icon: any;
    link?: string;
}

export default function DemoHoverBox({ title = '', description = '', icon = '', link = '' }: DemoHoverBoxProps) {
    return (
        <a
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            className={`bg-demo-BoxbackgroundColor no-underline box h-[200px] w-full rounded-2xl p-5 flex flex-col gap-2 text-center justify-center items-center transition-all duration-100 group border-2 border-transparent hover:border-primary hover:cursor-pointer hover:no-underline`}
        >
            <div className="flex flex-col justify-center items-center">
                <div className="bg-primary text-gray-900 h-[50px] w-[50px] rounded-full flex justify-center items-center transition-all duration-100">
                    {icon}
                </div>
                <h4 className="mt-3">{title}</h4>
                <p className="text-layout-textcolor">{description}</p>
            </div>
        </a>
    );
}
